import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import OrchestratorDashboard from "./OrchestratorDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/orchestrator" element={<OrchestratorDashboard />} />
          <Route path="/" element={<Navigate to="/orchestrator" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
